export const LoadingSkeleton = () => {
  return (
    <div className="h-full flex flex-col items-center justify-center px-6 py-8">
      <div className="text-center max-w-2xl mx-auto">
        <div className="mb-6 flex justify-center">
          <div className="h-16 w-16 rounded-lg animate-pulse bg-gray-200 dark:bg-neutral-800" />
        </div>
        <div className="h-8 w-48 mx-auto mb-4 rounded animate-pulse bg-gray-200 dark:bg-neutral-800" />
        <div className="h-4 w-64 mx-auto mb-6 rounded animate-pulse bg-gray-200 dark:bg-neutral-800" />
      </div>
    </div>
  );
};
